angular.module('lf.common')

.factory('cartService', function ($http, $rootScope, $log, preloadData, siteService) {
  
  function handleResponse(data, eventType, eventArgs) {
    data = data.data;
    if (!data) return;
    if (data.error) {
      if (data.error.details) {
        $log.warn(data.error.details.join('|'));
      }
      return;
    }
    if (data.shop) {
      $rootScope.shop = data.shop;
    }
    $rootScope.$broadcast(eventType, eventArgs);
  }
  
  var cartService = {
    
    add: function (params) {
      // params.id, params.skuId
      // $http invocation returns Promise
      var siteData = siteService.getSiteData(params.product.siteId);
      $log.debug(siteData);
      
      return $http({
        method: 'POST',
        url: siteData.siteBaseUrl + preloadData.shopActionPath,
        params: {
          // all ATG fields here + product specific
          atg_productId: params.product.id,
          atg_catalogRefIds: '[' + params.product.skuId + ']',
          atg_quantity: '1',
          atg_siteId: siteData.siteId,
          getData: 'shoppingActionResponse',
          updateData: 'true',
          action: 'addItemToOrder',
          amplifiHandler: '/atg/commerce/order/purchase/CartModifierFormHandler'
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .success(function(data) {
          params.product.type = siteData.siteProductType;
          handleResponse(data, 'cart:add', params.product);
        });
      
    },
    
    changeQuantity: function (params) {
      // params.id, params.skuId
      // $http invocation returns Promise
      return $http({
        method: 'POST',
        url: preloadData.shopAction,
        params: {
          // all ATG fields here + product specific
          atg_checkForChangedQuantity: true,
          atg_updateCommerceItemId: params.product.cartItemId,
          atg_quantity: params.product.updateQuantity,
          atg_siteId: preloadData.siteId,
          atg_setOrderErrorURL: 'NOOP',
          getData: 'shoppingActionResponse',
          updateData: 'true',
          action: 'setOrderByCommerceId',
          amplifiHandler: '/atg/commerce/order/purchase/CartModifierFormHandler'
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .success(function(data) {
          handleResponse(data, 'cart:changeQuantity', params.product);
        });
      
    },
    
    remove: function (params) {
      return $http({
        method: 'POST',
        url: params.product.siteBaseUrl + preloadData.shopActionPath,
        params: {
          // all ATG fields here + product specific
          atg_removalCommerceIds: '[' + params.product.cartItemId + ']',
          getData: 'shoppingActionResponse',
          updateData: 'true',
          action: 'removeItemFromOrder',
          amplifiHandler: '/atg/commerce/order/purchase/CartModifierFormHandler'
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .success(function (data) {
          handleResponse(data, 'cart:remove', params.product);
        });
    },
    
    applyCoupon: function (params) {
      return $http({
        method: 'POST',
        url: preloadData.shopAction,
        params: {
          atg_couponCode: params.couponCode,
          getData: 'shoppingActionResponse',
          updateData: 'true',
          action: 'claimCoupon',
          amplifiHandler: '/atg/commerce/promotion/CouponFormHandler'
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .success(function (data) {
          if (data.data && data.data.shop) {
            $rootScope.shop = data.data.shop;
          }
          $rootScope.$broadcast('cart:coupon', params.couponCode);
      });
    },
    
    getShippingOptions: function (params) {
      return $http({
        method: 'GET',
        url: preloadData.shippingOptions,
        params: {
          zipCode: params.postalCode,
          isCartZipCode: true
        }
      })
    },
    
    getCartItemsCount: function (cart) {
      var cart = $rootScope.shop[cart + 'Cart'];
      if (!cart) return 0;
      return cart.items.reduce(function (count, item) {
        return count += parseInt(item.quantity);
      }, 0);
    },
    
    getHardgoodsCartItemsCount: function () {
      return cartService.getCartItemsCount('hardgoods');
    },
    
    getSoftgoodsCartItemsCount: function () {
      return cartService.getCartItemsCount('softgoods');
    }
  }
  
  return cartService;
  
});
